import gql from 'graphql-tag'
import { useEffect, useMemo, useState } from 'react'

import { TopTradersQuery } from './__generated__/types-and-hooks'
import { apolloCompetitionClient } from './apollo'

const query = gql`
  query TopTraders($step: Int!, $skip: Int!) {
    users(first: $step, skip: $skip) {
      id
      totalVolume
      clearVolume
    }
  }
`

export interface ITopTrades {
  error?: any
  isLoading: boolean
  data: TopTradersQuery['users']
}

export default function useTopTraders(): ITopTrades {
  const [users, setUsers] = useState<TopTradersQuery['users']>([])

  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  async function fetchData() {
    const step = 1000
    let length = step
    const fetchedUsers: TopTradersQuery['users'] = []

    try {
      for (let skip = 0; length === step; skip += step) {
        const results = await apolloCompetitionClient.query<TopTradersQuery>({
          query,
          variables: { step, skip },
        })
        length = results.data.users.length
        fetchedUsers.push(
          ...results.data.users.map((v) => ({
            ...v,
            clearVolume: Number(v.clearVolume),
            totalVolume: Number(v.totalVolume),
          }))
        )
      }

      setUsers(fetchedUsers.sort((a, b) => (a.totalVolume < b.totalVolume ? 1 : -1)))
    } catch (e) {
      console.log(e)
      setError(e)
    }

    setIsLoading(false)
  }

  useEffect(() => {
    if (!isLoading) {
      fetchData()
    }
    setIsLoading(true)

    const intervalId = setInterval(() => {
      if (!isLoading) {
        fetchData()
      }
      setIsLoading(true)
    }, 10000)
    return () => {
      clearInterval(intervalId)
    }
  }, [])

  return useMemo(
    () => ({
      error,
      isLoading,
      data: users,
    }),
    [users, error, isLoading]
  )
}
